$(document).ready(function () {
  $(".carousel-container").slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    mobileFirst: true,
    lazyLoad: false,
    prevArrow:
      '<button class="carousel-button prev"><img alt="prev" width="auto" height="20" src="https://cdn.shopify.com/s/files/1/0889/1741/0115/files/Vector_6043042f-6327-4645-bcee-5349a37887ae.svg?v=1732762304"></button>',
    nextArrow:
      '<button class="carousel-button next"><img alt="prev" width="auto" height="20" src="https://cdn.shopify.com/s/files/1/0889/1741/0115/files/Vector_1_74522783-8615-443f-81fe-da16b0ef2b81.svg?v=1732762376"></button>',
    responsive: [
      {
        breakpoint: 350,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 0,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
  console.log("Slick inicializado!");
});

$(".next").on("click", function () {
  $(".carousel-container").slick("slickNext");
  console.log("Slick next");
});

$(".prev").on("click", function () {
  $(".carousel-container").slick("slickPrev");
  console.log("Slick prev");
});
